<template>
  <q-card class="auth-card">
    <q-card-main>
      <!-- Success message -->
      <div v-if="requestSuccessful" class="success">
        <check-mark></check-mark>
        <h4 class="text-center">{{ $t('forgot_success_title') }}</h4>
        <p class="text-center">{{ $t('forgot_success_body') }}</p>
      </div>

      <template v-else>
        <h1 class="text-center auth-card__heading">{{ $t('forgot_heading') }}</h1>
        <p class="text-center auth-card__description">{{ $t('forgot_description') }}</p>

        <form id="forgot-form" @submit.prevent="handleForgot">
          <!-- Username -->
          <q-field :error="errors.has('email')" :error-label="errors.first('email')">
            <q-input
              name="email"
              v-model="email"
              v-validate.disable="'required|email|max:255'"
              type="email"
              :float-label="$t('email')"
              required
              autofocus/>
          </q-field>

          <div class="auth-card__footer row justify-between">
            <div class="col-md-auto col-xs-12 self-center auth-card__secondary-action">
              <router-link :to="{ name: 'login' }" class="router-link">{{ $t('goto_login') }}</router-link>
            </div>

            <div class="col-md-auto col-xs-12 self-center auth-card__primary-action" v-if="!requestSuccessful">
              <q-btn type="submit" color="primary">{{ $t('forgot') }}</q-btn>
            </div>
          </div>
        </form>
      </template>
    </q-card-main>
  </q-card>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { UserClient } from 'src/api/Users'
  import { createErrorFromResponse } from 'src/utils/error'
  import { debounce } from 'quasar'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        email: '',
        requestSuccessful: false
      }
    },

    methods: {
      handleForgot: debounce(function () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.forgot()
          })
      }, 500, true),

      forgot () {
        new UserClient().forgotPassword(this.email)
          .then(() => {
            this.requestSuccessful = true
          })
          .catch(createErrorFromResponse)
      },

      handleToLogin () {
        this.$router.replace({ name: 'login' })
      }
    },

    components: {
      CheckMark
    }
  }
</script>
